import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {  useParams } from 'react-router-dom';
import { getMethod } from '../Apis/apis';
import { createPortal } from 'react-dom';
import Loading from '../utils/Loading';
import EmptyRecord from '../utils/EmptyRecord';
import Header from './Header';

const Container = styled.div`
    max-width: 480px;
    min-height: 100vh;
    opacity: 1;
    background-color: #F4F4F4;
    background-attachment: fixed;
    margin: 0 auto;
    position: relative;
    // padding-bottom: 70px;
`

const HeaderDiv = styled.div`
   padding: 10px 20px;
   display:flex;
   align-items: center;
   background-color: ${props => props.theme.primary};
   border-bottom: 1px solid #5dd7ff;

   img {
     width: 60px;
     margin-left: 15px;
   }
   button {
      border: none;
      outline: none;
      background-color: transparent;
      font-size: 30px;
      color: #FFF;
      position: absolute;
      right: 20px;

      div {
        position: relative;
      }

      span {
        font-size: 12px;
        background-color: red;
        width: 20px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items:center;
        border-radius: 50%;
        position: absolute;
        top: 0;
        right: -5px;
      }
   }
`

const ContainerDiv = styled.div`
   padding: 0 20px 20px 20px;
`
const Ul = styled.ul`

`
const Li = styled.li`
    background-color: ${props => props.theme.primary};
    padding: 13px;
    border-radius: 10px;
    border: 1px solid #FFF;
    box-shadow: 2px 2px 4px #a8a8aa;
    user-select: none;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 10px;

    &:last-child {
        margin-bottom: 0;
    }

    span {
        font-weight: bolder;

        &:first-child {
            color: #FFF;
            font-size: 18px;
        }
        &:nth-child(2),&:nth-child(3){
            color: #FFF;
            font-size: 18px;
        }
        &:last-child {
        color: #FFF;
          font-size: 18px;
            div {
              &:last-child {
                color: #000;
                font-size: 21px;
                letter-spacing: .6px;
              }
            }
        }
        
    }
`

const ResultTitle = styled.li`
    padding: 10px 0;
    font-size: 20px;
    color: #908F94;
    text-align: center;
    font-weight: bolder;
`

const TabUl = styled.ul`
    display: grid;
    grid-template-columns: auto auto;
    margin-bottom: 10px;
`

const ListTab = styled.li`
    background-color: #FFF;
    padding: 7px;
    border-radius: 10px;
    border: 1px solid #FFF;
    user-select: none;
    color: #000;
    background-color: #e3e3e3;
    text-align: center;
    cursor: pointer;
`

const Result = () => {
  const [result,setResult] = useState([]);
  const [loading,setLoading] = useState(true);
  const date = useParams();
  const [twod,setTwod] = useState(true);
  const [threed,setThreed] = useState(false);

  useEffect(()=>{
    (async () =>{
      setLoading(true);
      setTwod(true);
      setThreed(false);
      let res = await getMethod(`/number/filter?date=${date.date}`);
      if(res){
        setLoading(false);
        if(res.con){
           if(res.data){
            setResult(res.data);
           }
        }
      };
    })();
  },[date]);

  const twodHandler = async () => {
    setTwod(true);
    setThreed(false);
    setLoading(true)
      let res = await getMethod(`/number/filter?date=${date.date}`);
      if(res){
        setLoading(false);
        if(res.con){
           if(res.data){
            setResult(res.data);
           }else{
            setResult([]);
           }
        }
    };
  };

  const threedHandler = async () => {
    setThreed(true);
    setTwod(false);
    setLoading(true)
    let resThreed = await getMethod(`/number3d/filter?date=${date.date}`);
    if(resThreed){
      setLoading(false);
      if(resThreed.con){
         if(resThreed.data){
          setResult(resThreed.data);
         }else{
          setResult([]);
         }
      }
    };
  }

  return (
    <Container>
      <Header status={true} />
    <ContainerDiv>
      <Ul>
            <ResultTitle>{date.date}</ResultTitle>
            <TabUl>
              <ListTab onClick={twodHandler}
                  style={{
                    color: twod ? '#FFF':"#000",
                    backgroundColor: twod ? "#2993CF":"#e3e3e3"
                  }}
                  >
                      2D
                  </ListTab>
                  <ListTab onClick={threedHandler}
                  style={{
                    color: threed ? '#FFF':"#000",
                    backgroundColor: threed ? "#2993CF":"#e3e3e3"
                  }}
                  >
                      3D
              </ListTab>
            </TabUl>
            {
              result.length > 0 ?
              result.map((el,index) => 
              <Li key={index}>
                  <span>
                    <div>Time</div>
                    <div>{el.time}</div>
                  </span>
                  <span>
                    <div>Set</div>
                    <div>
                        {el.set.split(".")[0]}.
                        {
                          el.set.split(".")[1].slice(0, -1)
                        }
                        <div style={{color: "#000",display: 'inline-block'}}>
                          {el.set.split(".")[1][el.set.split(".")[1].length - 1]}
                        </div>
                    </div>
                  </span>
                  <span id='value'>
                    <div>Value</div>
                    {
                      twod ?
                      <div>
                          {el.value.split(".")[0]}.
                          {
                            el.value.split(".")[1].slice(0, -1)
                          }
                          <div style={{color: "#000",display: 'inline-block'}}>
                            {el.value.split(".")[1][el.value.split(".")[1].length - 1]}
                          </div>
                      </div>
                      :
                      <div>
                          {el.value.split(".")[0]}
                          .
                          {
                            el.value.split(".")[1].slice(0, -2)
                          }
                          <div style={{color: "#000",display: 'inline-block'}}>
                            {el.value.split(".")[1]}
                          </div>
                      </div>
                    }
                    
                  </span>
                  <span>
                    <div>Result</div>
                    <div>{el.result}</div>
                  </span>
              </Li>
              )
              :
              <EmptyRecord message={`မှတ်တမ်းမရှိပါ`} />
            }
      </Ul>   
      </ContainerDiv>
    {
        createPortal( loading && <Loading />, document.getElementById("portal"))
    }
    </Container>
  )
}
export default Result;